import {NewSubAccount, SubAccount} from '@/subaccount/types/SubAccount'
import {Fulfillment} from '@/assignments/Assignment.type'

export const SET_SUB_ACCOUNT_EDITOR_CONTENT = 'SET_SUB_ACCOUNT_EDITOR_CONTENT'

export type SetSubAccountEditorContent = {
    content: SubAccount | NewSubAccount,
    panelId: number,
    fulfillment?: Fulfillment
}
